import { getApiUrl } from 'src/shared/lib/getApiUrl';

export type Dimensions = {
  width: number;
  height: number;
};

export type AuthOptions = {
  authMethods: {
    id: string;
    name: string;
    type: 'SSO' | 'PASSWORD';
    identityProvider: string | null;
  }[];
  organisationId: string;
};

export async function getAuthOptions(): Promise<AuthOptions | null> {
  try {
    const res = await fetch(`${getApiUrl()}/api/v2/public/organisation/authoptions`, {
      headers: {
        origin: window.location.origin,
      },
    });
    const data = await res.json();

    if (res.status === 404) {
      return null;
    }

    if (!res.ok) {
      throw new Error(data);
    }
    return data;
  } catch (err) {
    console.debug('Error loading auth options: ' + err);
    return null;
  }
}

export async function getLogo(): Promise<string | null> {
  try {
    const res = await fetch(`${getApiUrl()}/api/v2/public/organisation/logo`, {
      headers: {
        origin: window.location.origin,
      },
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data);
    }
    return data.logo ?? null;
  } catch (err) {
    console.debug('Error loading company logo: ' + err);
    return null;
  }
}

export function getDimensions(url: string): Promise<Dimensions | undefined> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      resolve(undefined);
    };
    img.src = url;
  });
}
